var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 4,
    viewBox: "0 0 4 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84476 3.50077C1.89074 3.54275 1.96205 3.53951 2.00403 3.49352C2.04602 3.44754 2.04277 3.37622 1.99678 3.33424L0.60601 2.06458H3.72467C3.78694 2.06458 3.83741 2.01411 3.83741 1.95184C3.83741 1.88957 3.78694 1.8391 3.72467 1.8391H0.606661L1.99678 0.570033C2.04277 0.528052 2.04602 0.45674 2.00403 0.410754C1.96205 0.364768 1.89074 0.361522 1.84476 0.403503L0.285205 1.82724C0.253649 1.85605 0.235648 1.89383 0.231204 1.93287C0.230159 1.93904 0.229614 1.94538 0.229614 1.95184C0.229614 1.9579 0.230092 1.96385 0.231012 1.96965C0.235111 2.00931 0.253175 2.04779 0.285205 2.07704L1.84476 3.50077Z",
    fill: "#303135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.d48a47f1157685cb52aab1dc0f5b9e8a.svg";
export { ForwardRef as ReactComponent };